<template>
	<div class="card-item-wrapper p-d-12">
		<div class="card-item">
			<div @click="detail">
				<div class="top-card">
					<div class="f-semi f-16 f-c-black" v-if="!isSearch">{{ customer.nama }}</div>
					<div class="f-semi f-16 f-c-black" v-else v-html="searchHighlight(customer.nama, keySearch)"></div>
					<div class="card-chevron"></div>
				</div>
				<div class="f-regular f-13 f-c-midgrey m-t-4">
					Total {{ customer.total_transaksi }} Transaksi
				</div>
				<div class="f-regular f-13 f-c-midgrey m-t-4">
					{{ customer.transaksi_terakhir }}
				</div>
			</div>
			<div class="separator-line m-x-min m-t-10" v-if="customer.telp !== ''"></div>
			<div class="bottom-card m-t-8 d-flex-between-center" style="position: relative"
			     v-if="customer.telp !== ''"
			>
				<div class="f-regular f-14 f-c-midgrey" v-if="!isSearch">
					{{ customer.telp }}
				</div>
				<div class="f-regular f-14 f-c-black" v-else v-html="searchHighlight(customer.telp, keySearch)"></div>
				<div class="clik"
				     :id="'dropdownMenuLink'+customer"
				     data-toggle="dropdown"
				     aria-haspopup="true"
				     aria-expanded="false">
				</div>
				<button type="button" class="btn btn-outline-primary f-12" style="padding: 2px 8px;">
					Hubungi
					<img src="../../../assets/icons/chevron-rotate-down.svg" alt=""
					     class="m-l-4" style="height: 14px">
				</button>
				<div class="dropdown-menu garis-listkomisi">
					<a class="dropdown-item icon-2" :href="'tel:' + customer.telp" target="_blank">
					<span class="mar-right-10">
						<img src="../../../assets/icons/phone-call.svg">
					</span>
						Telepon
					</a>
					<a class="dropdown-item icon-2" :href="'sms:' + customer.telp" target="_blank">
					<span class="mar-right-10">
						<img src="../../../assets/icons/email.svg">
					</span>
						SMS
					</a>
					<a class="dropdown-item icon-2" :href="'http://wa.me/' + customer.telp" target="_blank">
					<span class="mar-right-10">
						<img src="../../../assets/icons/mdi_whatsapp.svg">
					</span>
						Whatsapp
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOCardCustomerGlobal",
	props: [
		"customer",
		"keySearch",
		"isSearch",
	],
	methods: {
		detail(event) {
			this.$emit("detail", event)
		}
	}
}
</script>

<style scoped>
.dropdown-menu.garis-listkomisi.show {
	top: -132px !important;
}
</style>